import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import {
  selectAseIsEditable,
  selectAseIsOnline,
} from 'store/assessments/selectors';

import { SectionDisplay } from './PagesMain/SectionDisplay';
import { SectionEdit } from './PagesMain/SectionEdit';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ASSESSMENT],
  Screens.ASE_SECTION
>;

export const SectionScreen: React.FC<Props> = ({ navigation, route }) => {
  const isEditable = useSelector(selectAseIsEditable);
  const isOnline = useSelector(selectAseIsOnline);
  return isEditable && !isOnline ? (
    <SectionEdit navigation={navigation} route={route} />
  ) : (
    <SectionDisplay navigation={navigation} route={route} />
  );
};
